import channelTypes from 'shared/constants/channel-types';


export function isVODChannel(channelData) {
  return channelData.channelType === channelTypes.CHANNEL;
}

export function isYouTubeFeed(channelData) {
  return channelData.channelType === channelTypes.YOUTUBE_FEED;
}

export function hasTags(channelData) {
  const tags = _.get(channelData, 'statsInfo.tags');
  return !_.isEmpty(tags);
}

export function hasDescription(channelData) {
  return Boolean(channelData.description);
}

export function hasVideos(channelData) {
  return channelData.videosCount > 0;
}



// WEBPACK FOOTER //
// ./src/shared/utils/channel-helpers.js